export default "__VITE_ASSET__81bdc417__"